import { monitors } from "../../fixtures";

const wait = async (timeout = 400) => {
  await new Promise((resolve) => {
    setTimeout(resolve, timeout);
  });
};

export const getMonitorById = async (monitorId: string) => {
  await wait();

  const monitor = monitors.filter(
    (monitor) => !monitor._deleted && monitor.id === monitorId,
  )[0];
  if (!monitor) {
    throw new Error("Could not find monitor");
  }

  return monitor;
};
